export var ReceiptStatus;
(function (ReceiptStatus) {
    ReceiptStatus[ReceiptStatus["ENTERED"] = 1] = "ENTERED";
    ReceiptStatus[ReceiptStatus["FULFILLED"] = 2] = "FULFILLED";
    ReceiptStatus[ReceiptStatus["VOID"] = 3] = "VOID";
})(ReceiptStatus || (ReceiptStatus = {}));
//# sourceMappingURL=receipt-status.js.map